/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Customer_GroupsInputs */

const vi_nav_customer_groups = /** @type {(inputs: Nav_Customer_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm khách hàng`)
};

/**

* @param {Nav_Customer_GroupsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_customer_groups = /** @type {((inputs?: Nav_Customer_GroupsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Customer_GroupsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_customer_groups(inputs)
});